import busEvents from '@/helper/busEvents';
import { useEffect } from 'react';

const useDelayBalanceUpdate = (delayMs = 0) => {
  useEffect(() => {
    busEvents.emit('delayBalanceUpdate', delayMs);
    return () => {
      busEvents.emit('delayBalanceUpdate', 0);
    };
  }, [delayMs]);
};

export default useDelayBalanceUpdate;
